import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getNotificationAuction } from "../../../../redux/action/notification";
import ButtonRepeathandle from "../children/ButtonRepeathandle";
import NotificationDetails from "../children/NotificationDetails";

const buttonConfigSeller = [
  { label: "All", type: "" },
  { label: "Inspection", type: "inspection-request" },
  { label: "Pickup", type: "pickup" },
];

const buttonConfigBuyer = [
  { label: "All", type: "" },
  { label: "Auction", type: "new-auction" },
  { label: "Pickup", type: "pickup" },
];

function AllNotificationComponent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [notificationType, setNotificationType] = useState("");
  const { notificationArray } = useSelector((state) => state?.notifications);
  const { accountType } = useSelector((state) => state.account);
  const [storeNotification, setStoreNotification] = useState([]);

  useEffect(() => {
    dispatch(getNotificationAuction());
  }, [dispatch]);

  useEffect(() => {
    setStoreNotification(notificationArray?.notifications);
  }, [notificationArray]);

  useEffect(() => {
    if (notificationType === "") {
      setStoreNotification(notificationArray?.notifications);
    } else {
      setStoreNotification(
        notificationArray?.notifications.filter((item) => {
          return item.type === notificationType;
        })
      );
    }
  }, [notificationType, notificationArray]);

  return (
    <div className="mt-1">
      <span className="valign-wrapper" style={{ gap: "25px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate("/")}
        >
          arrow_back
        </span>
        <h3 className="font-cercular-bold ">Notification</h3>
      </span>
      <div className="flex gap-2">
        <div style={{ width: "230px" }}>
          {(accountType === "industry"
            ? buttonConfigSeller
            : buttonConfigBuyer
          ).map((config, index) => (
            <ButtonRepeathandle
              key={index}
              label={config.label}
              type={config.type}
              notificationType={notificationType}
              setNotificationType={setNotificationType}
            />
          ))}
        </div>
        <div className="border-1px">
          {storeNotification?.map((item) => (
            <NotificationDetails items={item} key={item._id} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default AllNotificationComponent;
